import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import ComplianceConnectService from "@app/compliance-connect/common/complianceConnectService";
import { ComplianceConnectFilterOptions } from "@app/compliance-connect/regulator/complianceConnectTypes";

interface UseComplianceConnectFilterOptionsResult {
    filterOptions: ComplianceConnectFilterOptions | null;
    filterOptionsError: boolean;
    isLoading: boolean;
}

export function useComplianceConnectFilterOptions(): UseComplianceConnectFilterOptionsResult {
    const service = useRef(new ComplianceConnectService()).current;

    const { data, error, isPending } = useQuery({
        queryFn: ({ signal }) => service.getFilterOptions(signal),
        queryKey: ["cc-filter-options"],
        staleTime: 5 * 60 * 1000,
    });

    return {
        filterOptions: data ?? null,
        filterOptionsError: error != null,
        isLoading: isPending,
    };
}
